<template lang="pug">
div
	.infosheet
		div.many-before.mb-6(style="background-image: url(https://static.wintersport.nl/images/nskiv/currently.jpg); height:145px;")
			.text-center
				.white--text.headline.font-weight-black.px-4.pt-4 351.477 wintersporters gingen je voor!
				.white--text.font-weight-bold.pt-2 - sinds 1978 -
		ad(location="sidebar").mb-6

	maintenance
</template>

<script>
import Maintenance from '@/components/verzekering/maintenance.vue';

export default {
	name: 'InsuranceShortCalculate',
	nuxtI18n: {
		paths: {
			'nl-NL': '/verzekering/kortlopende-reisverzekering/afsluiten'
		}
	},
	components: {
		Maintenance
	},
	asyncData({ app }) {
		app.ads({});
		app.meta({
			title:
				'Premie kortlopende reisverzekering berekenen - Nederlandse Ski Vereniging',
			description:
				'Bereken de premie van dé reisverzekering voor wintersporters. Voorkom problemen door een matige dekking.'
		});
		app.breadcrumbs({
			[app.i18n.t('page.insurance:breadcrumb')]: { name: 'verzekering' },
			[app.i18n.t('page.insurance.travel:breadcrumb')]: {
				name: 'verzekering-kortlopend'
			},
			[app.i18n.t('page.insurance.short.calculate:breadcrumb')]: {
				name: 'verzekering-kortlopend-calculate'
			}
		});
	},
	head() {
		return {
			...this.$structuredData()
		};
	}
};
</script>
